import { render, staticRenderFns } from "./ipad-theme-home.vue?vue&type=template&id=e22338fa&scoped=true&"
import script from "./ipad-theme-home.vue?vue&type=script&lang=js&"
export * from "./ipad-theme-home.vue?vue&type=script&lang=js&"
import style0 from "./ipad-theme-home.vue?vue&type=style&index=0&id=e22338fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22338fa",
  null
  
)

export default component.exports